const topics = [
  { name: '长相思', heat: '2.8万讨论', rank: 1, icon: 'ri-fire-line' },
  { name: '庆余年第二季', heat: '2.5万讨论', rank: 2, icon: 'ri-fire-line' },
  { name: '你比星光美丽', heat: '1.9万讨论', rank: 3, icon: 'ri-fire-line' },
  { name: '与凤行', heat: '1.7万讨论', rank: 4, icon: 'ri-discuss-line' },
  { name: '繁花', heat: '1.5万讨论', rank: 5, icon: 'ri-discuss-line' },
  { name: '古装剧推荐', heat: '1.3万讨论', rank: 6, icon: 'ri-discuss-line' },
  { name: '暑期追剧清单', heat: '1.2万讨论', rank: 7, icon: 'ri-thumb-up-line' },
  { name: '悬疑剧天花板', heat: '1.0万讨论', rank: 8, icon: 'ri-thumb-up-line' },
  { name: '韩剧入坑指南', heat: '0.9万讨论', rank: 9, icon: 'ri-thumb-up-line' },
  { name: '1080P高清', heat: '0.8万讨论', rank: 10, icon: 'ri-thumb-up-line' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="relative py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-500/10 border border-secondary-500/20 mb-4">
            <i className="ri-hashtag text-secondary-400 text-xs"></i>
            <span className="text-secondary-300 text-xs font-medium">热门话题</span>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900">
            大家都在讨论
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            热门剧集话题实时热度，看看剧迷们都在聊什么
          </p>
        </div>

        <div className="flex flex-wrap gap-3 md:gap-4 justify-center">
          {topics.map((topic) => (
            <div
              key={topic.name}
              className="group relative flex items-center gap-3 px-4 py-3 rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-300/50 hover:bg-primary-50/30 transition-all duration-200 cursor-pointer"
            >
              <span className={`w-6 h-6 rounded-md flex items-center justify-center text-xs font-bold ${
                topic.rank <= 3
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-secondary-100 text-secondary-600'
              }`}>
                {topic.rank}
              </span>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-1.5">
                  <i className={`${topic.icon} text-xs ${topic.rank <= 3 ? 'text-primary-500' : 'text-foreground-400'}`}></i>
                  <span className="text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors">
                    {topic.name}
                  </span>
                </div>
              </div>
              <span className="text-[11px] text-foreground-400 whitespace-nowrap">{topic.heat}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}